import React, { useState, useEffect } from 'react';
import { Chip } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { authService } from '../services/AuthService';

const OrganizationBadge: React.FC = () => {
  const { t } = useTranslation();
  const [assumedOrg, setAssumedOrg] = useState(authService.getAssumedOrganization());

  useEffect(() => {
    setAssumedOrg(authService.getAssumedOrganization());
  }, []);

  if (!assumedOrg.id || !assumedOrg.name) {
    return null;
  }

  const handleClear = () => {
    authService.clearAssumedOrganization();
    setAssumedOrg({ id: null, name: null });
    // Force page reload to ensure all components are re-rendered with new state
    window.location.reload();
  };

  return (
    <Chip
      label={t('organizations.assumedOrganization', 'Viewing as: {{name}}', { name: assumedOrg.name })}
      color="primary"
      variant="outlined"
      onDelete={handleClear}
      deleteIcon={<CloseIcon fontSize="small" />}
      sx={{ 
        height: 32,
        maxWidth: { xs: '120px', sm: 'none' },
        '& .MuiChip-label': {
          px: 1,
          fontSize: { xs: '0.7rem', sm: '0.75rem' },
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        },
        '& .MuiChip-deleteIcon': {
          fontSize: '1rem',
          margin: '0 4px 0 -6px',
          '&:hover': {
            color: 'inherit'
          }
        }
      }}
    />
  );
};

export default OrganizationBadge; 